module.exports = __webpack_public_path__ + "media/images/bitmap/main-image-5a4231ba662fa05ff8df7dfa195d2083.png";